import React from "react";
import { useTranslation } from "react-i18next";

function LegendItem(props) {
  const { t } = useTranslation();

  return (
    <div
      className="legend-row"
      style={{
        height: `${
          props.availableFilters
            ? 100 / (props.availableFilters.length + 1)
            : 20
        }%`,
        display: `${
          props.availableFilters?.includes(props.type) ? "flex" : "none"
        }`,
      }}
    >
      <div className="legend-item">
        {" "}
        <div
          className={`${props.type.toLowerCase()}-icon`}
          style={{
            backgroundColor: props.hotspotColors[props.type].defaultColor,
          }}
        ></div>{" "}
      </div>
      <div className="legend-item">
        <p>{props.type}</p>
        <p>
          {t("APARTMENT")} <br /> {props.type[1]} {props.type === "T1" ? t("PIECE") : t("PIECES")}
        </p>
      </div>
    </div>
  );
}

export default LegendItem;
